(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ChartCareTeam', ChartCareTeam);

    ChartCareTeam.$inject = ['$resource', 'DateUtils'];

    function ChartCareTeam ($resource, DateUtils) {
        var resourceUrl =  'api/chart-care-team/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAllByFilter': {url: 'api/chart-care-team/filter', method: 'GET', isArray: true},
        });
    }
})();
